import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';

interface WithdrawConsentInfoModalProps {
  onClose: () => void;
  organizerName: string;
}

const WithdrawConsentInfoModal = ({
  onClose,
  organizerName,
}: WithdrawConsentInfoModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader title="Wycofanie akceptacji" onClose={onClose} />
      <ModalContent>
        <p className="text-sm text-neutral-700">
          Jeśli wycofanie akceptacji jest możliwe, poproś o to organizatora (
          {organizerName}), kontaktując się z nim bezpośrednio.
        </p>
      </ModalContent>
      <ModalFooter>
        <ActionButton tone="outline" size="sm" onClick={onClose}>
          Zamknij
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

export default WithdrawConsentInfoModal;
